module.exports = __webpack_public_path__ + "img/out_of_office.d3f83903.jpg";